module.exports = __webpack_public_path__ + "static/img/BM.3deb0152.png";